import {Component, Input} from '@angular/core';
import {InvalidValuesModel} from "../../../../domain/dao/invalid-values.model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-invalid-values',
  templateUrl: './invalid-values.component.html',
  styleUrls: ['./invalid-values.component.css'],
  standalone: false
})
export class InvalidValuesComponent {


  @Input() data: InvalidValuesModel[] = [];

  constructor(public modal: NgbActiveModal) {
  }

}
